import React from 'react';
import { withRouter } from 'react-router';

class ScrollToTop extends React.Component<any> {
  public componentDidUpdate(prevProps: any) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  public render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
